export default {
  soon: 'soon',
  telegram: 'Telegram',
  email: 'email newsletter',
  cpText: '© BIMLIB LLC',
  offer: 'Offer',
  userAgreement: 'Terms of Use',
  privacyPolicy: 'Privacy Policy',
  expandMenu: 'Expand menu',
  collapseMenu: 'Collapse menu',
  callText: 'We will consult you for free on any questions.',
  menu: {
    title1: 'Main',
    link11: 'BIM-models',
    link12: 'Reading Room',
    link13: 'Manufacturers',
    link14: 'My account',
    link15: 'Terms and conditions',
    link16: 'Calculators',
    link17: 'Partners programm',
    link18: 'Open statistics',

    title2: 'Сatalogs',
    link21: 'Revit BIM families',
    link22: 'Civil 3D BIM families',
    link23: 'Archicad BIM Objects',
    link24: 'Renga BIM Objects',
    link25: 'IFC models',

    title3: 'Company',
    link35: 'Tariffs',
    link36: 'Partnership',
    link31: 'About us',
    link32: 'Careers',
    link34: 'Our cases',

    title4: 'Our services',
    link41: 'BIMLIB App',
    link42: 'BIMLIB CAD plugin',
    link43: 'IRMA',
    link44: 'COSTX',
  }
}
